import React from 'react'
import { Row, Col, Card, Accordion, Table } from 'react-bootstrap';
import { computeTotals, roundOffPercentage } from '../../store/actions/projects/projectCostingActions';
import { toMonetaryFormat } from '../../common/Utilities';
import ProjectScopeSetting from './ProjectScopeSetting';

function PlatformCard({
  project, 
  newDetails, 
  forApproval, 
  platform,
  scopes, 
  bands,
  costingTotals, 
  onCalculate,
  onAddBandCosts,
  readOnly
}) {
  const displayBlendedRate = () => {
    let blendedRate = 0;
    let projEstimate = 0;
    let taskDistributions = 0;
    let fullyLoadedCost = 0;

    bands && bands.forEach(band => {
      let taskDistribution = 0;
      if (typeof(band.totalCostPerBand) !== "undefined") {
        blendedRate += band.totalCostPerBand;
      }

      if (typeof(band.totalBandManHours) !== "undefined") {
        projEstimate += band.totalBandManHours;
      }

      let roundedProjEstime = Math.round(projEstimate);

      if (roundedProjEstime > projEstimate) {
        const difference = parseFloat((roundedProjEstime - projEstimate).toFixed(2));
        if (difference === 0.01) {
          projEstimate = roundedProjEstime;
        }
      }
      else {
        const difference = parseFloat((projEstimate - roundedProjEstime).toFixed(2));
        if (difference === 0.01) {
          projEstimate = roundedProjEstime;
        }
      }

      if (typeof(band.taskDistribution) !== "undefined") {
        taskDistribution = band.taskDistribution;
        taskDistributions += taskDistribution;
      }
      
      fullyLoadedCost += taskDistribution * band.cost;
    })

    taskDistributions = roundOffPercentage(parseFloat(taskDistributions.toFixed(2)));

    return (
      <tr>
        <td><b>Blended Rate</b></td>
        <td className="align-center"><b>{taskDistributions.toFixed(2) + "%"}</b></td>
        <td className="align-center"><b>{toMonetaryFormat(fullyLoadedCost)}</b></td>
        <td className="align-center"><b>{projEstimate.toFixed(2)}</b></td>
        <td className="align-center"><b>{toMonetaryFormat(blendedRate)}</b></td>
      </tr>
    )
  }

  const setBandsFields = () => {
    let bandRows = [];

    if (bands) {
      bandRows = bands.length ? (
        bands.map((band, key) => {
          let totalCostPerBand = 0;
          let totalBandManHours = 0;
          //total cost and man hours is not part of bands object 
          //until there we're filled up
          if (typeof(band.totalCostPerBand) !== "undefined") {
            totalCostPerBand = band.totalCostPerBand;
          }

          if (typeof(band.totalBandManHours) !== "undefined") {
            totalBandManHours = band.totalBandManHours.toFixed(2);
          }

          return (
            <tr key={key}>
              <td>
                Band {band.band_details.band_name} 
              </td>
              <td>
                <input type="number" 
                  disabled={readOnly ? true : false}
                  className="num-input"
                  style={{"maxWidth": "100%"}} 
                  defaultValue={band.taskDistribution > 0 ? band.taskDistribution : ""} 
                  onBlur={(e) => {
                    onAddBandCosts(e, band);
                  }}
                  />
              </td>
              <td className="align-center">
                { toMonetaryFormat(band.cost) }
              </td>
              <td className="align-center">{totalBandManHours}</td>
              <td className="align-center">{toMonetaryFormat(totalCostPerBand)}</td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={5}>Loading...</td>
        </tr>
      )
    }
    else {
      bandRows = <tr>
                  <td colSpan={5}>No bands found.</td>
                </tr>
    }

    return bandRows;
  }
  
  let isFullyLoaded = forApproval ? newDetails.fully_loaded : project.fully_loaded;

  return (
    <Row className="mt-3">
      <Col xs={12} sm={12} md={12} lg={12} xl={12}>
        <Accordion defaultActiveKey="1" className="mt-3">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="1" onClick={(e) => {
              e.preventDefault();
            }}>
              <b>{platform.platform_name}</b>
            </Accordion.Toggle>
              <Card.Body>
                <Row>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Table>
                      <thead>
                        <tr>
                          <th className="align-center">Level</th>
                          <th className="align-center">Task Distribution</th>
                          <th className="align-center">{isFullyLoaded ? 'Fully Loaded Cost' : 'Unloaded Cost'}</th>
                          <th className="align-center">Project Estimate</th>
                          <th className="align-center">Project Cost</th>
                        </tr>
                      </thead>
                      <tbody>
                        { setBandsFields() }
                        { displayBlendedRate() }
                      </tbody>
                    </Table>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <ProjectScopeSetting scopes={scopes} 
                      platform={platform} 
                      costingTotals={costingTotals} 
                      onCalculate={onCalculate} 
                      computeTotals={computeTotals} 
                      readOnly={readOnly}
                      />
                  </Col>
                </Row>
              </Card.Body>
          </Card>
        </Accordion>
      </Col>
    </Row>
  )
}

export default PlatformCard
